import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import ErrorPage from '../ErrorPage';

type Props = { children: React.ReactNode };

const PrivateRoute = ({ children }: Props) => {
    return useSelector((state: RootState) => state.user.isAdmin) ? <>{children}</> : <ErrorPage />;
};

export default PrivateRoute;
